import React, { PropsWithChildren } from 'react'

import { Ul } from './fieldsContainer.styled'

export type InputViewFieldProps = PropsWithChildren<any>
export const FieldsContainer = ({ children }: InputViewFieldProps) => <Ul>{children}</Ul>
